import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import Aside from "./Aside";
import Header from "./Header";
import { LangUpdateContext } from "./LangContext";

import ErrorBoundary from "../component/ErrorBoundary";
import { getStore } from "../util/redux/store";

import "./style.scss";

export const Layout = props => {
  const updateLangFn = () => {
    setLang(prevState => ({
      ...prevState,
      updateLang: !prevState.updateLang,
    }));
  };
  const [lang, setLang] = useState({
    updateLang: false,
    updateLangFn: updateLangFn,
  });
  const me = getStore().getState().me;
  const location = useLocation();

  return (
    <div className="theme-1-light">
      <LangUpdateContext.Provider value={lang}>
        <Aside />
        <div id="content" className="app-content box-shadow-z3">
          <Header me={me} />
          <div className="app-body">
            {/* Keyed by pathname: a page crash is contained here (nav stays usable)
                and the boundary resets when the route changes. */}
            <ErrorBoundary key={location.pathname}>{props.children}</ErrorBoundary>
          </div>
        </div>
      </LangUpdateContext.Provider>
    </div>
  );
};
